// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../layers/google.nodejs.yarn/yarn_modules/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.servicesDiv {
  margin-top: 280px;
}

@media (max-width: 425px) {
  .servicesDiv {
    margin-bottom: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/CSS/Services.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;;AAIA;EACI;IACI,mBAAA;EADN;AACF","sourcesContent":["@import \"./variables\";\n\n.servicesDiv{\n    margin-top: 280px;\n}\n\n@media (max-width: 425px){\n    .servicesDiv{\n        margin-bottom:10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
